<script lang="ts">
	import { _ } from "svelte-i18n";
	import CreatePresentation from "../../common/createPresentation/CreatePresentation.svelte";
	import { CreatePresentationStateTag } from "../../common/createPresentation/logic/stateMachine";
	import Redirect from "../../common/Redirect.svelte";
	import { authenticator } from "../store/loginV2";
	import Denied from "./generate/Denied.svelte";
	import Error from "./generate/Error.svelte";
	import Generating from "./generate/Generating.svelte";
	import NewPresentationForm from "./generate/NewPresentationForm.svelte";
	import Quota from "./generate/Quota.svelte";
</script>

<div class="wrapper">
	<h2>{$_("landingpage.newPresentation.title")}</h2>
	<br />
	<CreatePresentation {authenticator} let:state>
		{#if state.tag === CreatePresentationStateTag.IDLE}
			<NewPresentationForm generatePresentation={state.createPresentation} />
		{:else if state.tag === CreatePresentationStateTag.CREATING}
			<Generating progress={state.progress} />
		{:else if state.tag === CreatePresentationStateTag.ERROR}
			<Error onRetry={state.retry} onRestart={state.restart} />
		{:else if state.tag === CreatePresentationStateTag.DENIED}
			<Denied retry={state.restart} reason={state.reason} />
		{:else if state.tag === CreatePresentationStateTag.QUOTA_EXCEEDED}
			<Quota />
		{:else if state.tag === CreatePresentationStateTag.CREATED}
			<Redirect to={`/view/${state.presentationId}/new`} />
		{/if}
	</CreatePresentation>
</div>

<style>
	.wrapper {
		max-width: 600px;
		margin: 1rem auto 0;
		padding: 1rem;
	}
</style>
